import { ShieldOff } from "lucide-react";

type ForbiddenPanelProps = {
  message?: string;
  onBack?: () => void;
};

export function ForbiddenPanel({ message, onBack }: ForbiddenPanelProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-border bg-surface p-8 text-center">
      <ShieldOff className="h-12 w-12 text-muted-foreground" />
      <h3 className="mt-4 text-lg font-semibold text-text">Accès refusé</h3>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        {message ?? "Vous n'avez pas les droits pour accéder à cette ressource. Demandez à un administrateur de vérifier vos permissions."}
      </p>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="mt-6 rounded-md bg-accent px-4 py-2 text-sm font-medium text-white hover:bg-accent-hover"
        >
          Retour
        </button>
      )}
    </div>
  );
}
